import preset from '@/@core/preset/preset'
import Vue from 'vue'
import zhHans from 'vuetify/es5/locale/zh-Hans'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  preset,
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
  },
  lang: {
    locales: { zhHans},
    current: 'zhHans',
  },
})
